<template>
  <div class="mvh100 padding-10 flex flex-col">
    <help-item :list="list" class="flex-1" type="my"></help-item>
  </div>
</template>
<script>

import helpItem from './help-item.vue'
export default {
  components: { helpItem },
  data(){
    return {
      list:[{
        name:'助力商品'
      },{
        name:'助力优惠券'
      }],
      current:0
    }
  },
  methods:{
    handleClick:function(current){
      console.log(this.current,current)
      this.current = current
    },
    goDetail:function(type){
      const param = {
        type:type,
        id:111
      }
      this.$navigateTo("help-detail",param)
    }
  }
}
</script>
<style lang="less">
.padding-10{
  padding: 10px 10px 0 10px;
}
.bg-common{
  background: #FFE4A4;
}
</style>